import React from 'react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
import { Star, Check, AlertTriangle } from 'lucide-react';
const URL_COMBO = 'https://www.compradigitalya.com/cart/42735822831687:1';
const URL_NEGOCIO = 'https://www.compradigitalya.com/cart/42735890038855:1';
export function Pricing() {
  return <section id="pricing" className="py-16 md:py-24 px-4 max-w-6xl mx-auto scroll-mt-16" data-id="element-269">
      {/* COUNTDOWN BLOCK */}
      <div className="text-center mb-12 md:mb-16" data-id="element-270">
        <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-271">
          ⏰ Precio de lanzamiento activo hoy
        </p>
        <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-2xl mx-auto" data-id="element-272">
          Asegurá el precio promocional{' '}
          <span className="text-primary" data-id="element-273">antes de que suba.</span>
        </h2>

        <div className="mb-6" data-id="element-274">
          <Countdown data-id="element-275" />
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 max-w-2xl mx-auto" data-id="element-276">
          <div className="inline-flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 text-red-400 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-277">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-278" /> Después sube
            $8.000 ARS
          </div>
          <div className="inline-flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 text-red-400 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-279">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-280" /> Esta promo
            no vuelve
          </div>
          <div className="inline-flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 text-red-400 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-281">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-282" /> Cupos
            limitados
          </div>
        </div>
      </div>

      {/* OFFER */}
      <div className="text-center mb-10 md:mb-12" data-id="element-283">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-3 leading-tight" data-id="element-284">
          Elegí cómo querés{' '}
          <span className="text-primary" data-id="element-285">resolver tu año</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-286">
        {/* OPTION 1 — COMBO COMPLETO */}
        <div className="bg-surface border border-zinc-800 rounded-3xl p-6 md:p-8 flex flex-col" data-id="element-287">
          <div className="mb-5" data-id="element-288">
            <div className="flex items-center gap-2 mb-2" data-id="element-289">
              <span className="text-3xl md:text-4xl" data-id="element-290">📘</span>
              <h3 className="text-xl md:text-2xl font-extrabold" data-id="element-291">
                Combo Completo
              </h3>
            </div>
            <p className="text-zinc-400 text-sm" data-id="element-292">6 Tomos + 6 Bonos</p>
          </div>

          <div className="bg-surface2 border border-zinc-800/60 p-4 rounded-xl mb-6 text-sm text-zinc-300 leading-relaxed" data-id="element-293">
            <span className="font-bold text-white" data-id="element-294">Ideal para:</span> Profes que
            quieren resolver todo el año de clases con un sistema progresivo
            completo.
          </div>

          <ul className="space-y-2 mb-6" data-id="element-295">
            {['6 Tomos PDF (240 clases)', '6 Bonos estratégicos', 'Acceso inmediato (5 min)', 'Garantía 7 días'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-296">
                <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" data-id="element-297" />
                <span className="text-zinc-200" data-id="element-298">{f}</span>
              </li>)}
          </ul>

          <div className="mb-6 flex-grow" data-id="element-299">
            <div className="text-zinc-500 line-through text-base font-bold mb-1" data-id="element-300">
              Antes: $51.000
            </div>
            <div className="text-xs text-zinc-400 mb-1 uppercase tracking-wide font-bold" data-id="element-301">
              Hoy
            </div>
            <div className="text-4xl md:text-5xl font-extrabold text-white" data-id="element-302">
              $19.990{' '}
              <span className="text-xl md:text-2xl text-zinc-400" data-id="element-303">ARS</span>
            </div>
          </div>

          <Button href={URL_COMBO} fullWidth className="py-4 text-base md:text-lg" data-id="element-304">
            👉 QUIERO MI COMBO COMPLETO
          </Button>
        </div>

        {/* OPTION 2 — COMBO + NEGOCIO (RECOMMENDED) */}
        <div className="relative bg-surface border-2 border-primary rounded-3xl p-6 md:p-8 flex flex-col shadow-[0_0_50px_rgba(74,222,128,0.18)] transform md:-translate-y-2" data-id="element-305">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-black font-extrabold px-4 py-1 rounded-full text-xs md:text-sm flex items-center gap-1 whitespace-nowrap shadow-[0_0_15px_rgba(74,222,128,0.6)]" data-id="element-306">
            <Star className="w-3.5 h-3.5 fill-black" data-id="element-307" /> MÁS ELEGIDO
          </div>

          <div className="mb-5" data-id="element-308">
            <div className="flex items-center gap-2 mb-2" data-id="element-309">
              <span className="text-3xl md:text-4xl" data-id="element-310">🏆</span>
              <h3 className="text-xl md:text-2xl font-extrabold" data-id="element-311">
                Combo + Negocio
              </h3>
            </div>
            <p className="text-primary text-sm font-medium" data-id="element-312">
              6 Tomos + 6 Bonos + Método Profe Empresario
            </p>
          </div>

          <div className="bg-primary/10 border border-primary/30 p-4 rounded-xl mb-6 text-sm text-zinc-200 leading-relaxed" data-id="element-313">
            <span className="font-bold text-white" data-id="element-314">Ideal para:</span> Profes que
            además quieren construir un negocio rentable, cobrar lo que valen y
            llenar sus grupos.
          </div>

          <ul className="space-y-2 mb-6" data-id="element-315">
            {['TODO el Combo Completo', 'Método Profe Empresario', 'Pricing Blindado Argentina', 'Scripts WhatsApp para cerrar', 'Modelo Suscripción Mensual', 'Protocolos lumbar/rodilla/hombro'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-316">
                <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" data-id="element-317" />
                <span className="text-white font-medium" data-id="element-318">{f}</span>
              </li>)}
          </ul>

          <div className="mb-6 flex-grow" data-id="element-319">
            <div className="text-zinc-500 line-through text-base font-bold mb-1" data-id="element-320">
              Antes: $76.000
            </div>
            <div className="text-xs text-primary mb-1 uppercase tracking-wide font-bold" data-id="element-321">
              Hoy
            </div>
            <div className="text-4xl md:text-5xl font-extrabold text-primary" data-id="element-322">
              $27.990{' '}
              <span className="text-xl md:text-2xl text-zinc-400" data-id="element-323">ARS</span>
            </div>
          </div>

          <Button href={URL_NEGOCIO} fullWidth className="py-4 text-base md:text-lg shadow-[0_0_25px_rgba(74,222,128,0.4)]" data-id="element-324">
            👉 QUIERO EL COMBO + NEGOCIO
          </Button>
        </div>
      </div>

      <p className="text-center text-xs md:text-sm text-zinc-400 mt-8" data-id="element-325">
        🔒 Pago 100% seguro · ⚡ Acceso en 5 minutos · 💳 Mercado Pago hasta 12
        cuotas
      </p>
    </section>;
}